import { environment } from './../../environments/environment';
import { Injectable, inject, signal } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';

// TODO: Tee nüüd kõik tüübid korda pls 🙏 väike refactor kulub ära kindlasti

export type PlaylistVideo = {
  videoId: number;
  youtubeId: string;
  title: string;
  channel: string;
  duration: number;
  position: number;
  views: number;
  uploadedAt: string;
  nickname: string;
};

export type PlaylistVideos = {
  name: string;
  videos: PlaylistVideo[];
};

export type AdvancePlaylist = {
  message: string;
  playlistId: number;
  newPosition: number;
};

export type AddVideoToPlaylist = {
  userId: number;
  playlistId: number;
  youtubeId: string;
  title: string;
  channel: string;
  duration: number;
  views: number;
  uploadedAt: string;
};

export type AddedVideo = {
  videoId: number;
  position: number;
  addedBy: string;
  nickname: string;
};

@Injectable({ providedIn: 'root' })
export class PlaylistService {
  private http = inject(HttpClient);

  // 🎯 Signal – hoiab järgmist videot
  nextVideo = signal<PlaylistVideo>({} as PlaylistVideo);
  nowPlaying = signal<PlaylistVideo>({} as PlaylistVideo);

  playlistVideos = signal<PlaylistVideo[]>([]);
  playlistName = signal<string | null>(null);

  // 🔁 Lae järgmine video antud playlisti ID põhjal
  loadNext(playlistId: number = 1) {
    this.http
      .get<PlaylistVideo>(
        `${environment.apiUrl}/playlist/${playlistId}/next`
      )
      .subscribe({
        next: video => {
          console.log('🎬 Next video loaded:', video);
          this.nextVideo.set(video);
        },
        error: err => {
          console.error('❌ Failed to load next video:', err);
        },
      });
  }

  loadPlaylist(playlistId: number = 1) {
    this.http
      .get<PlaylistVideos>(
        `${environment.apiUrl}/playlist/${playlistId}/videos`
      )
      .subscribe({
        next: data => {
          console.log('📼 Playlist loaded:', data);
          this.playlistVideos.set(data.videos);
          this.playlistName.set(data.name);
        },
        error: err => {
          console.error('❌ Failed to load playlist:', err);
        },
      });
  }

  addVideoToPlaylist(video: AddVideoToPlaylist) {
    this.http
      .post<AddedVideo>(`${environment.apiUrl}/playlist/add-video`, video)
      .subscribe({
        next: () => {
          console.log('📼 Video added to playlist:', video);
        },
        error: err => {
          console.error('❌ Failed to add video to playlist:', err);
        },
      });
  }

  setPlaylistPosition(position: number, playlistId: number = 1): void {
    this.http
      .get(
        `${environment.apiUrl}/playlist/${playlistId}/position?${position}`
      )
      .subscribe({
        next: () => {
          console.log(`✅ Playlist position set to ${position}`);
        },
        error: err => {
          console.error('❌ Failed to set playlist position:', err);
        },
      });
  }

  advancePlaylist(playlistId: number = 1): Observable<AdvancePlaylist> {
    return this.http.post<AdvancePlaylist>(
      `${environment.apiUrl}/playlist/${playlistId}/next`,
      null
    );
  }

  requestNextSong(playlistId: number = 1): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/playlist/${playlistId}/next-song`,
      null
    );
  }

  requestPreviousSong(playlistId: number = 1): Observable<void> {
    return this.http.post<void>(
      `${environment.apiUrl}/playlist/${playlistId}/previous-song`,
      null
    );
  }

  getNowPlaying(playlistId: number = 1): Observable<PlaylistVideo> {
    return this.http.get<PlaylistVideo>(
      `${environment.apiUrl}/playlist/${playlistId}/now-playing`
    );
  }
}
